export default "__VITE_ASSET__BqExzytX__"